export const leavereportDetails = [
  {
    key:"1",
    Image: "user-01.jpg",
    InvoiceID: "Inv-001",
    ClientName: "Michael Walker",
    Role: "CEO",
    CompanyName: "BrightWave Innovations",
    CreatedDate: "14/01/2024",
    DueDate: "15/01/2024",
    Amount: "$3000",
    Status: "Paid",
  },
  {
    key:"2",
    Image: "user-02.jpg",
    InvoiceID: "Inv-002",
    ClientName: "Sophie Headrick",
    Role: "Manager",
    CompanyName: "Stellar Dynamics",
    CreatedDate: "21/01/2024",
    DueDate: "25/01/2024",
    Amount: "$2500",
    Status: "Sent",
  },
  {
    key:"3",
    Image: "user-03.jpg",
    InvoiceID: "Inv-003",
    ClientName: "Cameron Drake",
    Role: "Director",
    CompanyName: "Quantum Nexus",
    CreatedDate: "20/02/2024",
    DueDate: "22/02/2024",
    Amount: "$2800",
    Status: "Partially Paid",
  },
  {
    key:"4",
    Image: "user-04.jpg",
    InvoiceID: "Inv-004",
    ClientName: "Doris Crowley",
    Role: "Consultant",
    CompanyName: "EcoVision Enterprises",
    CreatedDate: "15/03/2024",
    DueDate: "17/03/2024",
    Amount: "$3300",
    Status: "Sent",
  },
  {
    key:"5",
    Image: "user-05.jpg",
    InvoiceID: "Inv-005",
    ClientName: "Thomas Bordelon",
    Role: "Manager",
    CompanyName: "Aurora Technologies",
    CreatedDate: "12/04/2024",
    DueDate: "16/04/2024",
    Amount: "$3600",
    Status: "Paid",
  },
  {
    key:"6",
    Image: "user-06.jpg",
    InvoiceID: "Inv-006",
    ClientName: "Kathleen Gutierrez",
    Role: "Director",
    CompanyName: "BlueSky Ventures",
    CreatedDate: "20/05/2024",
    DueDate: "21/05/2024",
    Amount: "$2000",
    Status: "Partially Paid",
  },
  {
    key:"7",
    Image: "user-07.jpg",
    InvoiceID: "Inv-007",
    ClientName: "Bruce Wright",
    Role: "CEO",
    CompanyName: "TerraFusion Energy",
    CreatedDate: "06/07/2024",
    DueDate: "06/07/2024",
    Amount: "$3400",
    Status: "Sent",
  },
  {
    key:"8",
    Image: "user-08.jpg",
    InvoiceID: "Inv-008",
    ClientName: "Estelle Morgan",
    Role: "Manager",
    CompanyName: "UrbanPulse Design",
    CreatedDate: "02/09/2024",
    DueDate: "04/09/2024",
    Amount: "$4000",
    Status: "Paid",
  },
  {
    key:"9",
    Image: "user-09.jpg",
    InvoiceID: "Inv-009",
    ClientName: "Stephen Dias",
    Role: "CEO",
    CompanyName: "Nimbus Networks",
    CreatedDate: "15/11/2024",
    DueDate: "15/11/2024",
    Amount: "$4500",
    Status: "Partially Paid",
  },
  {
    key:"10",
    Image: "user-10.jpg",
    InvoiceID: "Inv-010",
    ClientName: "Angela Thomas",
    Role: "Consultant",
    CompanyName: "Epicurean Delights",
    CreatedDate: "10/12/2024",
    DueDate: "11/12/2024",
    Amount: "$3800",
    Status: "Paid",
  },
];
